import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => matchMedia(query).matches,
  );
}

/** Below Tailwind's `md`: one panel at a time (room list or room). */
export const useIsMobile = () => useMediaQuery('(max-width: 767px)');

/** A real keyboard and mouse, where shortcut hints make sense. */
export const useHasKeyboard = () => useMediaQuery('(hover: hover) and (pointer: fine)');

/** Phone browsers cannot share their screen; mobile is view-only (design §10). */
export const canShareScreen = typeof navigator.mediaDevices?.getDisplayMedia === 'function';
